import { HttpEvent, HttpHandler, HttpRequest, HttpInterceptor } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { GoToProfilePopUp } from '../../dashboard/store/patients/patient-form/patient-profile-form.actions';

@Injectable()
export class PatientProfileInterceptor implements HttpInterceptor {
  private store = inject(Store);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError(error => {
        if ((error.error || {}).goToProfile) {
          this.store.dispatch(new GoToProfilePopUp(error?.error?.patientId, error?.error?.message));
        }
        return throwError(() => error);
      }),
    );
  }
}
